export const RECENT_FAIL = 'RECENT_FAIL';
export const RECENT_REQUEST = 'RECENT_REQUEST';
export const RECENT_SUCCESS = 'RECENT_SUCCESS';

export const ALBUMS_FAIL = 'ALBUMS_FAIL';
export const ALBUMS_REQUEST = 'ALBUMS_REQUEST';
export const ALBUMS_SUCCESS = 'ALBUMS_SUCCESS';

export const FAVORITE_FAIL = 'FAVORITE_FAIL';
export const FAVORITE_REQUEST = 'FAVORITE_REQUEST';
export const FAVORITE_SUCCESS = 'FAVORITE_SUCCESS';
